import React  from 'react';
import { useTranslation } from 'react-i18next';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import moment from 'moment';


const TournamentSuccessfullDialog = ({ data, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const BTN_NAMES = { cancel: t('button.ok') };
  const LATE_BTN_NAMES = { confirm: t('tournaments.startTournament'), cancel: t('button.close') };
  const now = moment();
  const isStarted = data.startDate && now.isAfter(moment(data.startDate)); 

  return (
    <div className="tournaments__popup tournament__dialog__register">
      <div className="tournaments__popup__overlay tournaments__register__successfull__overlay" onClick={onClose} />
      <PopUpDialogTemplate
        title={t('tournaments.tournamentRegistration')}
        iconName="successfull"
        text = {t('tournaments.successfullyRegistered')}
        onClose={onClose}
        onConfirm={onConfirm}
        btnNames={isStarted ? LATE_BTN_NAMES : BTN_NAMES}
        btnClasses={{confirm: 'primary', cancel: 'secondary'}}
      />
    </div>
  )
}

export default TournamentSuccessfullDialog;